export default "__VITE_ASSET__C1S7CqUM__"